"use strict"; // Random number generator - requires a PRNG backend, e.g. prng4.js

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); // For best results, put code like
// <body onClick='rng_seed_time();' onKeyPress='rng_seed_time();'>
// in your main HTML document.

var prng4_1 = __importDefault(require("./prng4"));

var rng_state;
var rng_pool;
var rng_pptr;
var rng_psize = 256; // Mix in a 32-bit integer into the pool

function rng_seed_int(x) {
  rng_pool[rng_pptr++] ^= x & 255;
  rng_pool[rng_pptr++] ^= x >> 8 & 255;
  rng_pool[rng_pptr++] ^= x >> 16 & 255;
  rng_pool[rng_pptr++] ^= x >> 24 & 255;
  if (rng_pptr >= rng_psize) rng_pptr -= rng_psize;
} // Mix in the current time (w/milliseconds) into the pool


function rng_seed_time() {
  rng_seed_int(new Date().getTime());
} // Initialize the pool with junk if needed.


if (rng_pool == null) {
  rng_pool = [];
  rng_pptr = 0;
  var t = void 0;

  if (navigator.appName == 'Netscape' && navigator.appVersion < '5' && window.crypto) {
    // Extract entropy (256 bits) from NS4 RNG if available
    // @ts-ignore: Property 'random' does not exist on type 'Crypto'
    var z = window.crypto.random(32);

    for (t = 0; t < z.length; ++t) {
      rng_pool[rng_pptr++] = z.charCodeAt(t) & 255;
    }
  }

  while (rng_pptr < rng_psize) {
    // extract some randomness from Math.random()
    t = Math.floor(65536 * Math.random());
    rng_pool[rng_pptr++] = t >>> 8;
    rng_pool[rng_pptr++] = t & 255;
  }

  rng_pptr = 0;
  rng_seed_time(); //rng_seed_int(window.screenX);
  //rng_seed_int(window.screenY);
}

function rng_get_byte() {
  if (rng_state == null) {
    rng_seed_time();
    rng_state = (0, prng4_1["default"])();
    rng_state.init(rng_pool);

    for (rng_pptr = 0; rng_pptr < rng_pool.length; ++rng_pptr) {
      rng_pool[rng_pptr] = 0;
    }

    rng_pptr = 0; //rng_pool = null;
  } // TODO: allow reseeding after first request


  return rng_state.next();
}

function rng_get_bytes(ba) {
  var i;

  for (i = 0; i < ba.length; ++i) {
    ba[i] = rng_get_byte();
  }
}

function SecureRandom() {}

SecureRandom.prototype.nextBytes = rng_get_bytes;
exports["default"] = SecureRandom;